module.exports = __webpack_public_path__ + "img/ESCUDO 150X75 px.e7297539.png";